import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function emojiPluginTrigger(evt: PluginEvent, editor: Editor) {
    return evt.eventType === PluginEventType.KeyUp;
}
